// extracted by mini-css-extract-plugin
export default {"container":"hF-z","title":"iF-z","link":"jF-z"};